<template>
  <mdb-container class="gp-has-header">
    <div v-if="!executing && availableStores.length == 0">Sorry, there are no available stores for your country.</div>
    <div v-if="cartInfo && cartInfo.totalItems > 0" class="text-right">
      <router-link to="/cart">
        <mdb-icon color="danger" icon="shopping-cart" size="lg"/>
        <mdb-badge color="warning">{{ cartInfo.totalItems }}</mdb-badge>
      </router-link>
    </div>
    <div v-if="availableStores.length>0 && !currentStore" class="text-center">
      <h2>Select Your Store</h2>
      <div v-for="store in availableStores" :key="store.id">
        <mdb-btn @click="selectStore(store)">{{ store.name }}</mdb-btn>
      </div>
    </div>
    <div v-if="currentStore">
      <mdb-breadcrumb class="breadcrumb-with-arrows">
        <mdb-breadcrumb-item v-if="availableStores.length>1">
          <a href="" @click.prevent="startOver">Home</a>
        </mdb-breadcrumb-item>
        <mdb-breadcrumb-item>
          <a href="" @click.prevent="clearFilters">{{ currentStore.name }}</a>
        </mdb-breadcrumb-item>
        <mdb-breadcrumb-item v-for="bc in breadcrumbs" :key="bc.id">
          <a href="" @click.prevent="switchCategory(bc,true)">{{ bc.label }}</a>
        </mdb-breadcrumb-item>
      </mdb-breadcrumb>
    </div>
    <div v-if="!currentProduct && currentStore">
      <div class="mb-4">
        <div v-if="!currentCategory" class="text-center">
          <mdb-btn v-for="bc in categories" :key="bc.id"
                   rounded size="sm"
                   @click="switchCategory(bc,false)">{{ bc.label }}
          </mdb-btn>
        </div>
        <div v-if="currentCategory && currentCategory.children" class="text-center">
          <mdb-btn v-for="bc in currentCategory.children" :key="bc.id"
                   rounded size="sm"
                   @click="switchCategory(bc,false)">{{ bc.label }}
          </mdb-btn>
        </div>
      </div>
      <mdb-card v-if="products.length == 0">
        <mdb-card-body>
          <div class="text-info">Sorry, no products were found.</div>
        </mdb-card-body>
      </mdb-card>
      <mdb-row v-if="products.length > 0">
        <div v-for="(r,i) in products" :key="i" class="col-lg-3 col-md-12">
          <a href="" @click.prevent="viewProduct(r)">
            <mdb-card class="mb-4" ecommerce narrow style="min-height: 400px;">
              <mdb-view cascade hover>
                <mdb-card-image :src="r.defaultImageThumb"
                                style="background-color: #ffffff;"
                                top
                                waves
                ></mdb-card-image>
                <mdb-mask flex-center overlay="white-slight" waves></mdb-mask>
              </mdb-view>
              <mdb-card-body cascade>
                <p>{{ r.name }}</p>
                <div class="text-secondary">
                  <h5>{{ currentStore.currencySymbol }} {{ r.price | formatNumber }}</h5>
                </div>
                <div>
                  <mdb-badge v-for="(tag,i) in r.tags" :key="i" class="mr-2" color="secondary">{{
                      tag.name
                    }}
                  </mdb-badge>
                </div>
                <div v-if="r.inStock < 5 && r.inStock > 0" class="warning-color-dark text-white mt-4">
                  <i>Only {{ r.inStock }} left!</i>
                </div>
                <div v-if="r.inStock < 1" class="warning-color-dark text-white mt-4">
                  <i>Out of Stock</i>
                </div>
              </mdb-card-body>
            </mdb-card>
          </a>
        </div>
      </mdb-row>
    </div>
    <div v-if="currentProduct">
      <div class="text-right">
        <mdb-badge v-for="(tag,i) in currentProduct.tags" :key="i" class="mr-2" color="secondary">{{
            tag.name
          }}
        </mdb-badge>
      </div>
      <mdb-row>
        <mdb-col md="4">

          <a href="" @click.prevent="showSlideshow(defaultImage)">
            <img :src="currentProduct.defaultImageFull"
                 style="width:100%;"
            >
          </a>
          <div class="m-4">
            <span v-for="(img,i) in currentProduct.images" v-if="currentProduct.images.length>1" :key="i" class="m-1">
              <a href="" @click.prevent="showSlideshow(i)"><img :src="img.thumb" width="50px"/></a>
            </span>
          </div>
        </mdb-col>
        <mdb-col md="8">
          <mdb-row>
            <mdb-col md="4">
              <h2>{{ currentProduct.name }}</h2>
              <div class="text-secondary">
                <h5>{{ currentStore.currencySymbol }} {{ currentProduct.price | formatNumber }}</h5>
              </div>
            </mdb-col>
            <mdb-col v-if="currentProduct.inStock>0" md="4">
              <mdb-input v-model="currentProduct.quantity" :max="currentProduct.inStock" :min="1" :step="1"
                         label="Quantity"
                         type="number"/>
            </mdb-col>
            <mdb-col v-if="currentProduct.inStock>0" md="4">
              <mdb-btn icon="shopping-cart" @click="addToCart(currentProduct)">Add to Cart</mdb-btn>
            </mdb-col>
          </mdb-row>
          <div v-if="currentProduct.inStock < 5 && currentProduct.inStock > 0"
               class="warning-color-dark text-white mt-4">
            <i>Only {{ currentProduct.inStock }} left!</i>
          </div>
          <div v-if="currentProduct.inStock < 1" class="warning-color-dark text-white mt-4">
            <i>Out of Stock</i>
          </div>

          <user-content id="gp-product-description" :content="currentProduct.description" class="text-left mt-4"/>
        </mdb-col>
      </mdb-row>
    </div>
    <cust-lightbox :imgs="slideshowImages" :index="lbIndex" :visible="slideshowVisible"
                  @hide="slideshowVisible=false"></cust-lightbox>

  </mdb-container>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import yesNoModal from "../common/YesNoModal";
import gpSelect from "../common/GPSelect";
import UserContent from "../common/UserContent";
import CustLightbox from "../common/CustLightbox";

import {
  mdbBadge,
  mdbBreadcrumb,
  mdbBreadcrumbItem,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardImage,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbMask,
  mdbRow,
  mdbView,
} from "mdbvue";

export default {
  name: 'shopping',
  components: {
    mdbBadge,
    mdbContainer,
    mdbBtn,
    mdbIcon,
    yesNoModal,
    mdbCard,
    mdbCardHeader,
    mdbView,
    mdbCardImage,
    mdbRow,
    mdbCol,
    mdbCardBody,
    mdbInput,
    mdbMask,
    mdbBreadcrumb,
    mdbBreadcrumbItem,
    CustLightbox,
    gpSelect,
    UserContent
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    },
    executing: function () {
      return this.$store.state.executing
    }
  },
  filters: {
    formatNumber: function (val) {
      if (!val) return ""
      return val.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.currentProduct) {
      next(false)
      this.currentProduct = null
      return
    }
    next()
  },
  data() {
    return {
      cartInfo: null,
      availableStores: [],
      breadcrumbs: [],
      currentStore: null,
      categories: [],
      currentProduct: null,
      currentCategory: null,
      defaultImage: 0,
      products: [],
      selectVisible: true,
      lbIndex: 0,
      filters: {
        max: 25,
        query: "",
        offset: 0,
        tags: [],
        category: null
      },
      slideshowImages: [],
      slideshowVisible: false
    }
  }
  ,
  mounted() {
    document.title = "Shop"
    let url = "/shopping/availableStores"
    if (this.$route.params.store) {
      url = "/shopping/storeByUrl?store=" + this.$route.params.store
    }
    api.get(url).then(
      (results) => {
        this.availableStores = results.data
        if (this.availableStores.length == 1) {
          this.currentStore = this.availableStores[0]
          this.loadCategories()
          this.loadProducts()
        }
      },
      (error) => {
        this.$notify.error({message: error.response.data, timeOut: 20000})
      })

    this.getCarts()
  }
  ,
  methods: {
    getCarts() {
      api.get("/shopping/cartInfo").then(
        (results) => {
          this.cartInfo = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        })
    },
    startOver() {
      this.currentProduct = null;
      this.currentStore = null;
    },
    showSlideshow(start) {
      this.lbIndex = start;
      this.slideshowVisible = true
    },
    switchCategory(bc, fromBc) {
      if (fromBc) {
        let loc = this.breadcrumbs.indexOf(bc)
        this.breadcrumbs.length = loc + 1
      } else {
        this.breadcrumbs.push(bc)
      }
      this.filters.category = bc.id
      this.currentCategory = bc
      this.loadProducts()
    },
    categorySelected(cat) {
      this.loadProducts()
    },
    selectStore(store) {
      this.currentStore = store
      this.loadCategories()
      this.loadProducts()
    },
    clearFilters() {
      this.filters.query = ""
      this.filters.tags = []
      this.breadcrumbs = []
      this.filters.category = null
      this.currentCategory = null
      let forms = document.getElementsByTagName('form');
      this.selectVisible = false
      this.loadProducts()
      //stupid trick because the mdb-select element is not really reactive.
      this.$nextTick().then(() => {
        this.selectVisible = true
      });
    },
    loadProducts() {
      this.currentProduct = null
      api.post("/shopping/products/" + this.currentStore.id, this.filters).then(
        (results) => {
          this.products = results.data.products
          //this.breadcrumbs = results.data.breadcrumbs
          if (this.products.length > 0) this.filters.tags = results.data.tags
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        })
    },
    loadCategories() {
      api.get("/product/categoryTree?store=" + this.currentStore.id).then(
        (results) => {
          this.categories = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        })

    },
    viewProduct(p) {
      this.slideshowImages = []
      p.images.forEach((img, i) => {
        if (img.isDefault) this.defaultImage = i;
        this.slideshowImages.push({img: img.fullSize, thumbnail: img.thumb});
      })
      this.currentProduct = p
      this.$nextTick().then(() => {
        window.scrollTo(0, 0)
      })
    },
    addToCart(product) {
      this.$store.dispatch("setExecuting", true);
      const payload = {id: product.id, quantity: product.quantity}
      api.post("/shopping/addToCart/" + this.currentStore.id, payload).then(
        (results) => {
          this.$notify.success({message: product.name + " added to cart.", timeOut: 2000})
          this.cartInfo.totalItems += parseInt(product.quantity)
          this.currentProduct = null
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }

  }

}
;
</script>
